import * as constants from './constants';

export const initialState = [];

export default function NotificationsReducer(state = initialState, { payload, type }) {
  switch (type) {
    case constants.ADD_ITEM:
      return [...state, payload];

    case constants.ADD_ITEMS:
      return [...state, ...payload];

    case constants.DELETE_ITEM:
      return state.filter(({ id }) => id !== payload);

    case constants.DELETE_ITEMS:
      return initialState;

    default:
      return state;
  }
}
